import { paymentMethodsApi } from 'src/store/api/paymentMethods/requestHandlers';
import { IQueryParams } from 'src/types';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getMany = createAsyncThunk('bonuses/getMany', async ({ page, size, ...data }: IQueryParams) => {
  return await paymentMethodsApi.getMany({ page, size, ...data });
});

export const paymentMethodsActions = { getMany };
